import { Col } from "reactstrap";
import { BorderWidthTitle } from "../../../../constants";

const BorderWidth = () => {
  return (
    <Col xxl="3" sm="6">
      <div className="border-wrapper h-100 dark-helper alert-light-light">
        <h3 className="mb-3">{BorderWidthTitle}</h3>
        {[...Array(10)].map((_, index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box border border-${index + 1}`} />
            <span>{`.border-${index + 1}`}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
export default BorderWidth;
